import { type ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GoogleAccountSelect } from '@/components/connectors/google-account-select';
import { ROUTES } from '@/constants/routes';
import { loadNamespaces } from '@/lib/i18n/i18n';

const searchSchema = z.object({
  pending: z.string().min(1),
  from: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/connect-google-account')({
  loader: () => loadNamespaces('settings'),
  validateSearch: searchSchema,
  staticData: {
    hideAppShell: true,
    title: 'route.connect_google_account.title',
  },
  component: ConnectGoogleAccountPage,
});

function ConnectGoogleAccountPage(): ReactElement {
  const { pending, from } = Route.useSearch();
  return (
    <div className="bg-bg-page flex min-h-svh items-center justify-center p-6">
      <GoogleAccountSelect
        pending={pending}
        redirectTo={from ?? ROUTES.CONNECTORS}
        className="w-full max-w-md"
      />
    </div>
  );
}
